import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => {
  return {
    pageRoot: {
      paddingTop: "1.5rem",
      paddingBottom: "2rem",
    },
    headerCard: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: theme.spacing(2),
      backgroundColor: "#ffffff",
      borderRadius: 16,
      boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
      padding: theme.spacing(2, 2.5),
      marginBottom: theme.spacing(2),
    },
    pageTitle: {
      fontSize: "1.15rem",
      fontWeight: 700,
      color: "#1f2937",
    },
    headerRight: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      gap: theme.spacing(1.5),
    },
    filterField: {
      minWidth: 170,
    },
    viewToggle: {
      display: "flex",
      backgroundColor: "#2b2f36",
      borderRadius: 10,
      padding: 3,
    },
    viewToggleBtn: {
      minWidth: 96,
      color: "rgba(255,255,255,0.7)",
      textTransform: "none",
      fontWeight: 600,
      fontSize: "0.8rem",
      borderRadius: 8,
      padding: "4px 12px",
      "&:hover": { backgroundColor: "rgba(255,255,255,0.08)" },
    },
    viewToggleBtnActive: {
      backgroundColor: "#fff",
      color: "#1f2937",
      "&:hover": { backgroundColor: "#fff" },
    },
    tablePaper: {
      borderRadius: 16,
      boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
      padding: theme.spacing(3),
    },
    emptyRow: {
      textAlign: "center",
      color: "#9aa4b2",
      padding: theme.spacing(5, 2),
      fontSize: "0.9rem",
    },
    clickableCell: {
      padding: "18px 60px",
      fontSize: "0.95rem",
      cursor: "pointer",
      color: theme.palette.primary.main,
      fontWeight: 500,
      "&:hover": {
        textDecoration: "underline",
      },
    },
    statusChip: {
      fontWeight: 700,
      fontSize: "0.72rem",
    },
    dialogContent: {
      minWidth: 400,
      paddingTop: theme.spacing(2),
    },
    formField: {
      marginBottom: theme.spacing(2),
    },
    actionCell: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      gap: theme.spacing(2),
      minWidth: "280px",
    },
    actionsHeader: {
      textAlign: "right",
      paddingRight: theme.spacing(2),
    },
    tableCell: {
      padding: "16px 18px",
      fontSize: "0.95rem",
    },
  };
});
